import { RoomSearch } from '../search/room-search';
import { Genders } from '../user/genders';

export class RoomSearchProfile {
    roomSearch: RoomSearch;
    gender: Genders;
    includeAll: boolean;
    areasString: string;
    areas: any;
}
